var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArExp = function SvgArExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar-exp_svg__a)",
    d: "M20 31.667h-6.667V55H20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar-exp_svg__b)",
    d: "M40 31.667h-6.667V55H40z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar-exp_svg__c)",
    d: "M70 18.333 36.667 1.667 3.333 18.333V25H70z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar-exp_svg__d)",
    d: "M3.333 61.667v6.666h41.334c-.7-2.133-1.067-4.366-1.2-6.666z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar-exp_svg__e)",
    d: "M60 39.2v-7.533h-6.667v10.866z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar-exp_svg__f)",
    d: "M63.333 45 50 51.667v8.5c0 8.4 5.7 16.266 13.333 18.166 7.634-1.9 13.334-9.766 13.334-18.166v-8.5zm-2.4 23.333-6.766-6.766 3.533-3.534 3.233 3.234 8.034-7.934 3.533 3.534z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-exp_svg__a",
    x1: -27.253,
    x2: 75.216,
    y1: -27.083,
    y2: 70.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-exp_svg__b",
    x1: -27.253,
    x2: 75.216,
    y1: -27.083,
    y2: 70.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-exp_svg__c",
    x1: -27.253,
    x2: 75.216,
    y1: -27.083,
    y2: 70.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-exp_svg__d",
    x1: -27.253,
    x2: 75.216,
    y1: -27.083,
    y2: 70.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-exp_svg__e",
    x1: -27.253,
    x2: 75.216,
    y1: -27.083,
    y2: 70.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-exp_svg__f",
    x1: -27.253,
    x2: 75.216,
    y1: -27.083,
    y2: 70.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })))));
};
export { SvgArExp as ReactComponent };
export default "data:image/svg+xml;base64,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";